import type { Dexie } from "dexie";

// Version 4 dropped this table, but a tab of an older build adds it back,
// empty, the next time it opens the database. This build never declares it,
// so it is reached through the IndexedDB connection itself.
const STRAY_WORD_ARMS = "wordArms";

function inStrayWordArms(
  db: Dexie,
  keep: (key: IDBValidKey) => boolean,
): Promise<void> {
  // An executor that throws rejects: a connection Dexie closed for an old
  // tab's version change has no backendDB.
  return new Promise((resolve, reject) => {
    const idb = db.backendDB();
    if (!idb.objectStoreNames.contains(STRAY_WORD_ARMS)) {
      resolve();
      return;
    }
    const tx = idb.transaction(STRAY_WORD_ARMS, "readwrite");
    const request = tx.objectStore(STRAY_WORD_ARMS).openCursor();
    request.onsuccess = () => {
      const cursor = request.result;
      if (cursor === null) return;
      if (!keep(cursor.primaryKey)) cursor.delete();
      cursor.continue();
    };
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error ?? new Error("wordArms cleanup failed"));
    tx.onabort = () =>
      reject(tx.error ?? new Error("wordArms cleanup aborted"));
  });
}

/** Deletes one reader's study arms an older build's tab stored, if any. */
export const forgetStrayWordArms = (
  db: Dexie,
  readerId: string,
): Promise<void> =>
  inStrayWordArms(db, (key) => !Array.isArray(key) || key[0] !== readerId);

/** Empties an older build's study-arm table; dropping it would need a version bump. */
export const clearStrayWordArms = (db: Dexie): Promise<void> =>
  inStrayWordArms(db, () => false);
